import { render, staticRenderFns } from "./spec.vue?vue&type=template&id=17ce4f99&scoped=true&"
import script from "./spec.vue?vue&type=script&lang=js&"
export * from "./spec.vue?vue&type=script&lang=js&"
import style0 from "./spec.vue?vue&type=style&index=0&id=17ce4f99&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17ce4f99",
  null
  
)

export default component.exports